module.exports = __webpack_public_path__ + "static/media/proIcon.05b1e8c5.svg";